/*

FILE: main.js
DESCRIPTION: Entry point

*/

import { setElementRefs, elements } from './modules/elements';
import { setEventHandlers, removeEventHandlers } from './modules/events';
import { setState } from './modules/state';
import { initBarba } from './modules/pageLoader';
import { initWaypoints } from './modules/scroll';
import { initParallax } from './modules/parallax';
import { initAccordions } from './modules/accordions';
import { initCarousels } from './modules/carousels';
import { initSplideCarousels } from './modules/splideCarousels';
import { initLightboxes } from './modules/lightbox';
import { initVideos } from './modules/videos';
import { initVideoAlt } from './modules/videoAlt';
import { setActiveForm, initFreeformAjax } from './modules/forms';
import { initHeadlineEntrance } from './modules/animations';
import { initVideoBlocks } from './modules/videoBlock';
import { initBioModals } from './modules/modals';

import Alpine from 'alpinejs';

/*
	Methods
*/

// Set element and state values
const initState = (context) => {
	setElementRefs(context);
	setEventHandlers();
	setState();
}

// Init page-level modules
const initModules = () => {
	if (elements.headlineEntrance) { initHeadlineEntrance(elements.headlineEntrance) };
	if (elements.showTriggers.length) { setActiveForm() };
	if (elements.accordions.length) { initAccordions(elements.accordions) };
	if (elements.parallaxElements.length) { initParallax(elements.parallaxElements) };
	if (elements.carousels.length) { initCarousels(elements.carousels) };
	if (elements.splideCarousels.length) { initSplideCarousels(elements.splideCarousels) };
	if (elements.videoEmbedsAlt) { initVideoAlt(elements.videoEmbedsAlt) }
	if (elements.videoEmbeds) { initVideos(elements.videoEmbeds) }
	if (elements.videoBlocks) { initVideoBlocks(elements.videoBlocks) }
	initLightboxes();
}

// Reset/kill page-level modules
const unsetModules = () => { }

/*
	States
*/

const initOnPageTransition = (context) => {
	removeEventHandlers();
	unsetModules();
	initState(context);
	initModules();
	initFreeformAjax();
}

const initAfterPageTransition = (context) => {
	initWaypoints();
}

const initOnResize = () => {}

const initAlpine = () => {
	window.Alpine = Alpine;

	Alpine.start();
}

const initOnVisibilityChange = () => { }

/*
	Main init on load
*/

document.documentElement.classList.remove('no-js');
window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.preloadAfterLoad = true;
const lazysizes = require('lazysizes');
initState();
initModules();
initBarba();
initWaypoints();
initFreeformAjax();
initBioModals();
initAlpine();

export { initOnPageTransition, initAfterPageTransition, initOnResize, initOnVisibilityChange };
